import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Table } from 'reactstrap';
import useAxios from '../../hooks/useAxios';
import FetchStatus from '../../components/fetchStatus/FetchStatus';
import MyBadge from '../../components/myBadge/MyBadge';
import DayView from '../../components/dayView/DayView';
// import Pagination from '../../components/pagination/Pagination';

const AttendanceTab2 = () => {
  const api = useAxios();

  const { isLoading, data, error } = useQuery({
    queryKey: ['approved-requests'],
    queryFn: () =>
      api.get(`request/attendance/history`).then((res) => {
        return res.data.data;
      }),
  });

  return (
    <div className="border border-1 rounded-4 pt-1 pb-2 overflow-hidden">
      {isLoading ? (
        <FetchStatus type="loading" />
      ) : error ? (
        <FetchStatus type="error" />
      ) : data?.length > 0 ? (
        <Table hover responsive>
          <thead>
            <tr>
              <th style={{ textAlign: 'center', minWidth: '50px' }} width="50">
                No.
              </th>
              <th style={{ textAlign: 'center', minWidth: '100px' }}>Tanggal</th>
              <th style={{ textAlign: 'center', minWidth: '100px' }}>Jam Masuk (WIB)</th>
              <th style={{ textAlign: 'center', minWidth: '100px' }}>Jam Pulang (WIB)</th>
              <th style={{ textAlign: 'center', minWidth: '100px' }}>Keterangan</th>
              <th style={{ textAlign: 'center', minWidth: '100px' }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={item.id}>
                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{index + 1}</td>
                <td>
                  <DayView date={item.date} />
                </td>
                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                  {item.clock_in ? `${item.clock_in} WIB` : '-'}
                </td>
                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                  {item.clock_out ? `${item.clock_out} WIB` : `-`}
                </td>
                <td style={{ verticalAlign: 'middle' }}>{item.description}</td>
                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                  {item.status === 'pending' && <MyBadge color="blue">Pending</MyBadge>}
                  {item.status === 'approved' && <MyBadge color="green">Approved</MyBadge>}
                  {item.status === 'rejected' && <MyBadge color="red">Rejected</MyBadge>}
                  {item.status === 'cancelled' && <MyBadge color="purple">Cancelled</MyBadge>}
                  {item.status === 'ignored' && <MyBadge color="yellow">Cancelled</MyBadge>}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <FetchStatus type="empty" info="riwayat pengajuan" />
      )}

      {/* <Pagination  /> */}
    </div>
  );
};

export default AttendanceTab2;
